import cx from 'classnames';
import React from 'react';

import { CarouselContext } from '../context';

import './carousel__content.scss';

interface Props {
    children: React.ReactNode;
    mix?: string;
    'aria-label'?: string;
}

class CarouselContent extends React.Component<Props> {
    static contextType = CarouselContext;
    context!: React.ContextType<typeof CarouselContext>;

    itemRefs: HTMLElement[] = [];

    onItemRef = (ref: HTMLElement | null, itemIndex: number) => {
        if (ref) {
            this.itemRefs[itemIndex] = ref;
        }
    };

    onContentRef = (ref: HTMLElement | null) => {
        const { setContentRef } = this.context;

        setContentRef?.(ref, this.itemRefs);
    };

    render() {
        const { children, mix, 'aria-label': ariaLabel } = this.props;

        return (
            <div className="carousel__overflow-wrapper">
                <div
                    aria-label={ariaLabel}
                    className={cx('carousel__content', mix)}
                    ref={this.onContentRef}
                    role="list"
                >
                    {React.Children.map(children, (itemElement, itemIndex) => {
                        // @ts-ignore
                        return React.cloneElement(itemElement, {
                            ref: (ref: HTMLElement) => {
                                this.onItemRef(ref, itemIndex);
                            },
                        });
                    })}
                </div>
            </div>
        );
    }
}

export default CarouselContent;
